import { createFileRoute } from '@tanstack/react-router'
import { ResellersPage } from '@/features/operations'
import { requireRole } from '@/lib/auth-guards'

export const Route = createFileRoute('/_authenticated/resellers/')({
  component: ResellersPage,
  beforeLoad: requireRole(['admin']),
})
